import type { SocialLink } from '../types/social-links';

export const SOCIAL_LINKS: SocialLink[] = [
  {
    icon: 'https://www.victorsaisse.com/images/social/linkedin.png',
    title: 'LinkedIn',
    description: 'Victor Saisse',
    href: 'https://linkedin.com/in/victorsaisse',
  },
  {
    icon: 'https://www.victorsaisse.com/images/social/github.png',
    title: 'GitHub',
    description: 'victorsaisse',
    href: 'https://github.com/victorsaisse',
  },
  {
    icon: 'https://www.victorsaisse.com/images/social/x.png',
    title: 'X (Twitter)',
    description: '@victorsaisse',
    href: 'https://x.com/victorsaisse',
  },
  {
    icon: 'https://www.victorsaisse.com/images/social/instagram.png',
    title: 'Instagram',
    description: '@victorsaisse',
    href: 'https://instagram.com/victorsaisse',
  },
];
